import { useEffect, useState } from 'react';
import { OnlineshopProductImages } from '../../Interface/OnlineshopProductImages';

const DefaultImages: OnlineshopProductImages = {
  front_image_url: '',
  nutrition_facts_image_url: '',
  sell_sheets: [{ image_url: '' }],
};

const useValidImages = (images: OnlineshopProductImages) => {
  const [validImages, setValidImages] =
    useState<OnlineshopProductImages>(DefaultImages);

  useEffect(() => {
    if (images) {
      const loadImage = (src: string, callback: (src: string) => void) => {
        if (!src) return;
        const img = new window.Image();
        img.src = src;
        img.onload = () => callback(img.src);
      };

      if (images.front_image_url) {
        loadImage(images.front_image_url, (src) => {
          setValidImages((prev) => ({ ...prev, front_image_url: src }));
        });
      }

      if (images.nutrition_facts_image_url) {
        loadImage(images.nutrition_facts_image_url, (src) => {
          setValidImages((prev) => ({
            ...prev,
            nutrition_facts_image_url: src,
          }));
        });
      }

      if (images?.sell_sheets?.length > 0) {
        images.sell_sheets.forEach((img: { image_url?: string }) => {
          if (img.image_url) {
            loadImage(img.image_url, (src: string) => {
              setValidImages((prev) => ({
                ...prev,
                sell_sheets: [...(prev.sell_sheets || []), { image_url: src }],
              }));
            });
          }
        });
      }
    }

    return () => {
      setValidImages(DefaultImages);
    };
  }, [images]);

  return validImages;
};

export default useValidImages;
